export default __webpack_public_path__ + "static/media/Formular-Medium.8aa89703.ttf";